import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "paperclip"
const PaperclipIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M13.591 10.409C15.348 12.166 15.348 15.016 13.591 16.773L10.939 19.425C9.182 21.182 6.333 21.182 4.575 19.425 2.818 17.667 2.818 14.818 4.575 13.06L7.227 10.409Q7.407 10.229 7.601 10.076C7.566 10.709 7.631 11.346 7.796 11.962L5.636 14.122C4.464 15.291 4.464 17.191 5.636 18.363 6.808 19.535 8.707 19.535 9.879 18.364L12.53 15.712C13.702 14.541 13.702 12.642 12.53 11.47 12.237 11.177 12.237 10.702 12.53 10.409S13.298 10.116 13.591 10.409" />
          <path d="M19.425 4.575C21.182 6.333 21.182 9.182 19.425 10.94L16.773 13.591Q16.593 13.771 16.398 13.924C16.434 13.291 16.368 12.654 16.205 12.038L18.364 9.878C19.535 8.709 19.535 6.809 18.364 5.637S15.293 4.464 14.12 5.636L11.47 8.288C10.298 9.459 10.298 11.358 11.47 12.53 11.762 12.823 11.762 13.298 11.47 13.591 11.177 13.884 10.702 13.884 10.409 13.591 8.652 11.834 8.652 8.984 10.409 7.227L13.061 4.575C14.818 2.818 17.667 2.818 19.425 4.575" />
        </svg>
      }
    </span>
  )
}
export default PaperclipIcon
